/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
import type { DocumentModelUtils } from "document-model";
import type { RenownOidcClientPHState } from "./gen/types.js";
import { utils as genUtils } from "./gen/utils.js";
import * as customUtils from "./src/utils.js";

/** Utils for the RenownOidcClient document model */
export const utils: DocumentModelUtils<RenownOidcClientPHState> = {
  ...genUtils,
  ...customUtils,
};
